export default __webpack_public_path__ + "static/media/document-outline-16px.b0eaa407.svg";